export default {
  dataHome: [{
    collection_id: '1',
    template_id: '',
    type: 'template',
    no: '01',
    name: '詳細指定読取',
  }, {
    collection_id: '5',
    template_id: '7',
    type: 'export_xlsx',
    no: '02',
    name: '配置再現読取',
  }, {
    collection_id: '2',
    template_id: '6',
    type: 'business_card',
    no: '03',
    name: '名刺 OCR',
  }],
  dataActive: {},
}